import { useFlow } from '@stackflow/react';
import { useEffect } from 'react';
import { toast } from 'sonner';

function useGiftOrderInfo(orderNo: string) {
    const { replace, push } = useFlow();
    useEffect(() => {
        // PG 리다이렉트로 첫 진입 시 AppToaster 마운트 전이라 즉시 호출하면 토스트가 유실됨
        if (!orderNo) {
            replace('MainActivity', {});
            setTimeout(() => toast.error('주문 정보를 확인하지 못했어요. 주문 내역에서 확인해 주세요.'), 200);
        } else {
            replace('MainActivity', { fragment: 'GIFT' }, { animate: false });
            push('GiftSentActivity', {
                giftOrderNo: orderNo,
            });
            setTimeout(() => toast.success('선물이 발송되었습니다'), 200);
        }
    }, [orderNo]);
}

export default useGiftOrderInfo;
